import { render, staticRenderFns } from "./RenameFolderModal.vue?vue&type=template&id=06e0e61d&"
import script from "./RenameFolderModal.vue?vue&type=script&lang=js&"
export * from "./RenameFolderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports